export const preventLinkDefault = (event) => {
  event.preventDefault();
  event.currentTarget.blur();
};

export const scrollToSection = (section, offset = 80) => {
  const el = document.getElementById(section);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
};